import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthProvider';

const RoleRedirect = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    const storedRole = localStorage.getItem('user_role');

    if (!user && !storedRole) return;

    const role = (user?.role_name || storedRole)?.toLowerCase();

    switch (role) {
      case 'company':
        navigate('/company', { replace: true });
        break;
      case 'filer':
        navigate('/filer', { replace: true });
        break;
      case 'ermd':
        navigate('/ermd', { replace: true });
        break;
      case 'sod':
        navigate('/sod', { replace: true });
        break;
      case 'admin':
        navigate('/admin', { replace: true });
        break;
      default:
        navigate('/', { replace: true });
    }
  }, [user, navigate]);

  return null;
};

export default RoleRedirect;
